var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chj-button",class:{
        'chj-button-primary': _vm.primary,
        'chj-button-disabled': _vm.disabled,
        'chj-button-small': _vm.small,
        'chj-button-secondary': _vm.secondary
    }},[_vm._v("\n    "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }